import { combineRules } from 'fela';

export const container = ({ width, isSingle }) => ({
    width,
    position: 'relative',
    cursor: isSingle ? 'auto' : 'none',
});

export const extendContainer = {
    container: () => ({
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,

        tabletLarge: {
            padding: 0,
        },
    }),
};

export const testimonialContainer = {
    display: 'flex',
    flexDirection: 'column',

    alignItems: 'flex-start',
    marginBottom: '3.5rem',

    tablet: {
        flexDirection: 'row',
    },
};

export const quotes = {
    width: '1.5rem',
    height: '1.5rem',
    marginBottom: '2rem',
};

export const link = ({ theme: { colors } }) => ({
    color: colors.blue,

    ':hover': {
        cursor: 'none',
    },
});

export const extendTestimonial = {
    text: ({ theme: { colors } }) => ({
        fontSize: '1.5rem',
        lineHeight: '1.4',
        fontWeight: 'bold',
        marginTop: '-0.5rem',
        color: colors.black,

        tablet: {
            fontSize: '2rem',
            lineHeight: '3rem',
            marginLeft: '1rem',
        },
    }),
};

export const extendLinkTestimonial = {
    text: combineRules(extendTestimonial.text, ({ theme: { colors } }) => ({
        color: colors.blue,
    })),
};

export const authorContainer = {
    display: 'flex',
    paddingLeft: '2.5rem',
};

export const authorImage = {
    width: '4.875rem',
    height: '4.875rem',
    overflow: 'hidden',
    marginRight: '1.125rem',

    tabletLarge: {
        marginRight: '2.25rem',
    },
};

export const extendText = {
    text: () => ({
        fontWeight: 900,
    }),
};

export const extendCompanyText = {
    text: ({ theme: { colors } }) => ({
        fontWeight: 500,
        fontStyle: 'italic',
        color: colors.darkGrey,
    }),
};

export const logo = {
    marginTop: '1rem',
};
